import gql from 'graphql-tag';
import get from 'lodash/get';
import { useQuery } from '@apollo/react-hooks';

export const FINANCING_QUERY = gql`
  query financingQuery($id: ID!) {
    myBudget {
      _id
      step
      calculation {
        amount_of_loan {
          calculated_value
        }
        monthly_rate_loan {
          calculated_value
        }
      }
    }
    project(id: $id) {
      _id
      type
      pdf
      name
      price
      budget
      estimated_property_price
      type
      financing_rate
      loan {
        amount
        period
        loan_costs
        interest_type
        fixed_interest_period
        amount_with_loan_costs
        interest_rate
        monthly_rate
        own_funds_ratio
        max_loan_rate_ratio
        interest_bandwith
        is_own_funds_ratio_successful
        is_max_loan_rate_ratio_successful
      }
      progress {
        loan_viewed
        loan_request
      }
    }
  }
`;

const useGetFinancing = (projectId) => {
  const { loading, data } = useQuery(FINANCING_QUERY, {
    variables: { id: projectId },
    fetchPolicy: 'cache-and-network',
  });

  const budget = get(data, 'myBudget', null);
  const project = get(data, 'project', null);

  const financing = { project, budget };

  return [financing, loading];
};

export default useGetFinancing;
